import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=d5f8781c&scoped=true"
import script from "./ConsentBanner.vue?vue&type=script&lang=js"
export * from "./ConsentBanner.vue?vue&type=script&lang=js"
import style0 from "./ConsentBanner.vue?vue&type=style&index=0&id=d5f8781c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f8781c",
  null
  
)

export default component.exports